import React from 'react'
import { useTranslation } from 'react-i18next';
import chinaImg from '../assets/imgs/china.svg';
import kingdomImg from '../assets/imgs/united-kingdom.svg';

import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";

export default function LanguageCard() {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
  }

  return (
    <div className="flex flex-row z-[99999]">
      <Menu>
        <MenuHandler>
          {
            i18n.language == "en" ?
            <img src={kingdomImg} alt = "" className="rounded-full w-[30px] cursor-pointer"/>
            :
            <img src={chinaImg} alt = "" className="rounded-full w-[30px] cursor-pointer"/>
          }
        </MenuHandler>
        <MenuList className="bg-black border-black text-white text-md">
          <MenuItem>
            <div className="flex flex-row gap-2 items-center" onClick={() => changeLanguage('en')}>
              <img src={kingdomImg} alt = "" className="rounded-full w-[40px]"/>
              <div >ENGLISH</div>
            </div>
          </MenuItem>
          <MenuItem>
            <div className="flex flex-row gap-2 items-center" onClick={() => changeLanguage('ch')}>
              <img src={chinaImg} alt = "" className="rounded-full w-[40px]"/>
              <div>中国语文</div>
            </div>
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
}
